import { addYears, format, subMonths } from 'date-fns'
import * as Effects from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { IRequestPrices } from '../../actions/price/requestPrices'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchAirbnbPrices from '../../models/Integration/fetchAirbnbPrices'

function* getPrices(action: IRequestPrices) {
  try {
    const actionNames = fetchActionsName(ActionNames.FetchAirbnbPrices)

    const [{ service }] = yield Effects.all([
      Effects.take(actionNames.output),
      Effects.put(
        callFetch(actionNames.input, actionNames.output, fetchAirbnbPrices),
      ),
    ])

    const startDate = format(subMonths(new Date(), 1), 'YYYY-MM-DD')
    const finishDate = format(addYears(new Date(), 2), 'YYYY-MM-DD')

    const prices = yield Effects.call(service, startDate, finishDate)

    yield Effects.put({
      type: IntegrationAction.AcceptFetchPrice,
      payload: prices,
    })
  } catch (e) {
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeLatest(IntegrationAction.RequestPrices, getPrices)
}
